<div class="aurora-field account-shell" role="application">
  @if (isCompactViewport() && !isSidebarCollapsed()) {
  <button
    type="button"
    class="account-sidebar-backdrop"
    (click)="collapseSidebarForMobile()"
    [attr.aria-label]="'LAB_LAYOUT.COLLAPSE_SIDEBAR' | translate"
  ></button>
  }
  <aside
    class="account-sidebar"
    [class.collapsed]="isSidebarCollapsed()"
    [class.is-drawer-open]="isCompactViewport() && !isSidebarCollapsed()"
  >
    <div class="account-sidebar-inner">
      <div class="brand">
        <img
          class="brand-logo"
          [src]="isSidebarCollapsed() ? brandLogoMiniPath : brandLogoPath"
          [attr.alt]="brandTitleKey | translate"
          [class.brand-logo--collapsed]="isSidebarCollapsed()"
        />
      </div>

      <nav class="account-sidebar-nav" role="navigation" [attr.aria-label]="'LAB_LAYOUT.NAV_LABEL' | translate">
        @for (item of visibleMenuItems; track item.route) {
        <a
          [routerLink]="item.route"
          class="nav-item"
          [class.active]="isActiveRoute(item.route)"
          [attr.title]="item.label | translate"
          (click)="onNavItemClick()"
        >
          @switch (item.route) {
            @case ('/main') {
              <svg lucideLayoutDashboard [size]="18" [strokeWidth]="2"></svg>
            }
            @case ('/workorders') {
              <svg lucideClipboardList [size]="18" [strokeWidth]="2"></svg>
            }
            @case ('/design-projects') {
              <svg lucideSquarePen [size]="18" [strokeWidth]="2"></svg>
            }
            @case ('/calendar') {
              <svg class="nav-calendar-icon" lucideCalendarDays [size]="18" [strokeWidth]="2"></svg>
            }
            @case ('/payments') {
              <svg lucideWallet [size]="18" [strokeWidth]="2"></svg>
            }
          }
          @if (!isSidebarCollapsed()) {
          <span class="nav-item-label">{{ item.label | translate }}</span>
          }
        </a>
        }
      </nav>

      <div class="account-sidebar-footer">
        <button
          type="button"
          class="nav-item collapse-toggle"
          (click)="toggleSidebarCollapsed()"
          [attr.aria-label]="
            (isSidebarCollapsed() ? 'LAB_LAYOUT.EXPAND_SIDEBAR' : 'LAB_LAYOUT.COLLAPSE_SIDEBAR') | translate
          "
          [attr.title]="
            (isSidebarCollapsed() ? 'LAB_LAYOUT.EXPAND_SIDEBAR' : 'LAB_LAYOUT.COLLAPSE_SIDEBAR') | translate
          "
        >
          @if (isSidebarCollapsed()) {
            <svg lucidePanelsTopLeft [size]="18" [strokeWidth]="2"></svg>
          } @else {
            <svg lucideChevronsLeft [size]="18" [strokeWidth]="2"></svg>
          }
        </button>
      </div>
    </div>
  </aside>

  <main class="account-canvas">
    <header class="account-topbar" role="banner">
      <div class="account-layout-rail account-topbar-rail account-topbar-rail-end">
        <div class="topbar-actions">
          <div class="create-menu-wrap">
            <button
              type="button"
              class="create-button"
              [class.create-button--open]="isCreateMenuOpen()"
              [attr.aria-expanded]="isCreateMenuOpen()"
              [attr.aria-label]="'LAB_LAYOUT.CREATE' | translate"
              (click)="toggleCreateMenu(); $event.stopPropagation()"
            >
              <svg lucidePlus class="create-button__icon" [size]="14" [strokeWidth]="2" aria-hidden="true"></svg>
              <span class="create-button__label">{{ 'LAB_LAYOUT.CREATE' | translate }}</span>
            </button>
            @if (isCreateMenuOpen()) {
            <div class="quick-create-popover" role="menu">
              <ul class="quick-create-list">
                <li>
                  <button type="button" class="quick-create-item" role="menuitem" (click)="openCreate('/design-projects')">
                    <svg lucideSquarePen class="quick-create-item__icon" [size]="15" [strokeWidth]="1.85" aria-hidden="true"></svg>
                    <span>{{ 'LAB_LAYOUT.CREATE_DESIGN' | translate }}</span>
                  </button>
                </li>
                @if (developmentBuild) {
                <li>
                  <button type="button" class="quick-create-item" role="menuitem" (click)="openCreate('/workorders')">
                    <svg lucideWrench class="quick-create-item__icon" [size]="15" [strokeWidth]="1.85" aria-hidden="true"></svg>
                    <span>{{ 'LAB_LAYOUT.CREATE_WORK_ORDER' | translate }}</span>
                  </button>
                </li>
                <li>
                  <button type="button" class="quick-create-item" role="menuitem" (click)="openCreate('/payments')">
                    <svg lucideCreditCard class="quick-create-item__icon" [size]="15" [strokeWidth]="1.85" aria-hidden="true"></svg>
                    <span>{{ 'LAB_LAYOUT.CREATE_PAYMENT' | translate }}</span>
                  </button>
                </li>
                }
              </ul>
            </div>
            }
          </div>

          <lib-notifications
            appType="lab"
            (notificationsOpenChange)="onNotificationsOpenChange($event)"
          ></lib-notifications>

          <div class="user-menu-container">
            <button
              type="button"
              class="topbar-profile-pill"
              [attr.title]="userFullName"
              [attr.aria-label]="'LAB_LAYOUT.PROFILE_MENU' | translate"
              [attr.data-state]="isUserDropdownOpen() ? 'open' : null"
              [attr.aria-expanded]="isUserDropdownOpen()"
              (click)="toggleUserDropdown(); $event.stopPropagation()"
            >
              <span class="topbar-profile-photo" aria-hidden="true">
                @if (userAvatarUrl() && !avatarImageFailed()) {
                <img
                  [src]="userAvatarUrl()"
                  alt=""
                  class="topbar-profile-photo-img"
                  (error)="onAvatarImageError()"
                />
                } @else {
                <span class="topbar-profile-initials">{{ userInitials || '?' }}</span>
                }
              </span>
              <span class="topbar-profile-copy">
                <span class="topbar-profile-name">{{ userFullName || ('LAB_LAYOUT.SETTINGS' | translate) }}</span>
              </span>
              <svg lucideChevronDown [size]="14" [strokeWidth]="2"></svg>
            </button>

            @if (isUserDropdownOpen()) {
            <div
              class="account-row-menu settings-avatar-menu user-dropdown"
              role="menu"
              aria-orientation="vertical"
              data-side="bottom"
              data-align="end"
              data-state="open"
            >
              <div class="profile-menu-header">
                <span
                  class="profile-menu-name"
                  (mouseenter)="showEllipsisTooltip($event)"
                  (mouseleave)="hideEllipsisTooltip()"
                >{{ userFullName }}</span>
                @if (userEmail) {
                <span
                  class="profile-menu-email"
                  (mouseenter)="showEllipsisTooltip($event)"
                  (mouseleave)="hideEllipsisTooltip()"
                >{{ userEmail }}</span>
                }
              </div>
              <div role="separator" aria-orientation="horizontal" data-slot="dropdown-menu-separator"></div>
              @if (canOpenAccount()) {
              <button type="button" role="menuitem" data-slot="dropdown-menu-item" (click)="openAccount()">
                <svg lucideUser [size]="16" [strokeWidth]="1.85" aria-hidden="true"></svg>
                {{ 'LAB_LAYOUT.ACCOUNT' | translate }}
              </button>
              }
              <button type="button" role="menuitem" data-slot="dropdown-menu-item" (click)="openSettings()">
                <svg lucideSettings [size]="16" [strokeWidth]="1.85" aria-hidden="true"></svg>
                {{ 'LAB_LAYOUT.SETTINGS' | translate }}
              </button>
              <div role="separator" aria-orientation="horizontal" data-slot="dropdown-menu-separator"></div>
              <button
                type="button"
                role="menuitem"
                data-slot="dropdown-menu-item"
                data-variant="destructive"
                (click)="logout()"
              >
                <svg lucideLogOut [size]="16" [strokeWidth]="1.85" aria-hidden="true"></svg>
                {{ 'LAB_LAYOUT.LOGOUT' | translate }}
              </button>
            </div>
            }
          </div>
        </div>
      </div>
    </header>

    <div class="account-scroll">
      <div class="account-layout-rail account-page-rail lab-page">
        <ng-content></ng-content>
      </div>
    </div>
  </main>
</div>
@if (ellipsisTooltip(); as tip) {
<div class="profile-ellipsis-tooltip" [style.left.px]="tip.x" [style.top.px]="tip.y">{{ tip.text }}</div>
}
